import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { Export } from '@tripetto/runner';
import { TripettoAutoscroll } from '@tripetto/runner-autoscroll/runner/es5';
import Services from '@tripetto/studio';
import { PageTypes, getPagePaths } from '~/types/PageTypes';
import { acceptLanguage } from '~/i18n.config';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useUser } from '~/composables/_next/useUser';
import { generateTwicPicBackgroundImageSet } from '~/composables/useResponsiveBackground';
import { updateGlobalData } from '@/composables/skinCareGlobalData';
import { useWait } from '~/composables/_next/useWait';
import { getFormattedDateAndTime, getFormattedTime } from '@/helpers/formatDate';
import { klaviyoClientSubscriptionEvent } from '~/helpers/tracking/klaviyo';
import { instantScrollTo } from '~/helpers/ui/windowBehaviors';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'Survey',
  setup: function setup(__props) {
    var surveyContent = useState('generic-survey-content', function () {
      return null;
    });
    var surveyGenericTemplateCollection = computed(function () {
      var _surveyContent$value, _surveyContent$value$, _surveyContent$value$2;
      return surveyContent === null || surveyContent === void 0 ? void 0 : (_surveyContent$value = surveyContent.value) === null || _surveyContent$value === void 0 ? void 0 : (_surveyContent$value$ = _surveyContent$value.data) === null || _surveyContent$value$ === void 0 ? void 0 : (_surveyContent$value$2 = _surveyContent$value$.surveyGenericTemplateCollection) === null || _surveyContent$value$2 === void 0 ? void 0 : _surveyContent$value$2.items;
    });
    var router = useRouter();
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      error = _useNuxt2App.error,
      $trackers = _useNuxt2App.$trackers,
      $config = _useNuxt2App.$config;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated,
      user = _useUser.user;
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var tripettoRef = ref(null);
    var tripettoToken = computed(function () {
      var _surveyGenericTemplat, _surveyGenericTemplat2;
      return (_surveyGenericTemplat = surveyGenericTemplateCollection === null || surveyGenericTemplateCollection === void 0 ? void 0 : (_surveyGenericTemplat2 = surveyGenericTemplateCollection.value[0]) === null || _surveyGenericTemplat2 === void 0 ? void 0 : _surveyGenericTemplat2.idTripetto) !== null && _surveyGenericTemplat !== void 0 ? _surveyGenericTemplat : null;
    });
    var backgroundImage = ref();
    var surveyStarted = ref(false);
    var surveyComplete = ref(false);
    var numberQuestionsAnswered = ref(0);
    var nameQuestionYouStop = ref('');
    var LANGUAGE_PATHS = getPagePaths(acceptLanguage, PageTypes.SRE);
    var timeStart = ref();
    function initTripetto() {
      return _initTripetto.apply(this, arguments);
    }
    function _initTripetto() {
      _initTripetto = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tripetto, incrementAndTransferData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              incrementAndTransferData = function _incrementAndTransfer(selectedData) {
                numberQuestionsAnswered.value++;
                nameQuestionYouStop.value = selectedData;
              };
              tripetto = Services.init({
                token: tripettoToken.value
              });
              tripetto.styles.disableScrolling = false;

              /**
               * Increments the count of answered questions and updates the name of the last question stopped at.
               * @param {string} selectedData - The name of the selected question or the selected data to transfer.
               */
              _context2.next = 5;
              return TripettoAutoscroll.run(Services.get({
                token: tripetto.token,
                license: tripetto.license,
                removeBranding: true,
                element: tripettoRef.value,
                definition: tripetto.definition,
                styles: tripetto.styles,
                display: 'page',
                l10n: tripetto.l10n,
                locale: tripetto.locale,
                translations: function translations(_, context) {
                  return tripetto.translations(locale, context);
                },
                attachments: tripetto.attachments,
                onAction: function onAction(type, definition, block) {
                  switch (type) {
                    case 'start':
                      surveyStarted.value = true;
                      $trackers.gtm.pushEvent('skincare_diag', {
                        event_category: 'ecommerce',
                        event_action: 'survey',
                        event_label: 'survey_skincare',
                        event_name: 'survey_start',
                        event: 'survey_start'
                      });
                      break;
                    case 'stage':
                      incrementAndTransferData(block.name);
                      break;
                    case 'complete':
                      surveyComplete.value = true;
                      break;
                  }
                },
                onSubmit: function onSubmit(instance) {
                  var formDatas = Export.exportables(instance);
                  var emailObject = formDatas === null || formDatas === void 0 ? void 0 : formDatas.fields.find(function (object) {
                    return object.name === 'email';
                  });
                  klaviyoClientSubscriptionEvent(emailObject.value, locale, 'web-skincare-survey');
                  updateGlobalData(Export.exportables(instance), true);
                  router.push(app.localePath(LANGUAGE_PATHS[locale]));
                }
              }));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _initTripetto.apply(this, arguments);
    }
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            instantScrollTo({
              top: 0
            });
            startWaiter('survey');
            _context.next = 4;
            return client.contentful.getSurveyGeneric.query({
              locale: locale,
              slug: 'skincare'
            });
          case 4:
            surveyContent.value = _context.sent;
            if (!(surveyGenericTemplateCollection.value.length <= 0)) {
              _context.next = 8;
              break;
            }
            error({
              statusCode: 404
            });
            return _context.abrupt("return");
          case 8:
            backgroundImage.value = generateTwicPicBackgroundImageSet($config.public.cloudinaryDomain, surveyGenericTemplateCollection.value[0].background.url, 1200);
            initTripetto().then(function () {
              return endWaiter('survey');
            }).catch(function (error) {
              console.error(error);
              endWaiter('survey');
            });
            timeStart.value = new Date();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onUnmounted(function () {
      var _user$value;
      $trackers.gtm.pushEvent('skincare_diag', {
        event_category: 'ecommerce',
        event_action: 'survey_answer',
        event_label: 'survey_skincare',
        event_name: 'impression_survey_recape',
        ecommerce: {
          time_start: getFormattedDateAndTime(timeStart.value),
          time_end: getFormattedDateAndTime(new Date()),
          number_of_question: numberQuestionsAnswered.value,
          name_question_you_stop: nameQuestionYouStop.value,
          is_authenticated: isAuthenticated.value,
          user_id: (user === null || user === void 0 ? void 0 : (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.id) || false,
          survey_started: surveyStarted.value,
          survey_complete: surveyComplete.value,
          duration: getFormattedTime(new Date() - timeStart.value)
        }
      });
    });
    return {
      __sfc: true,
      surveyContent: surveyContent,
      surveyGenericTemplateCollection: surveyGenericTemplateCollection,
      router: router,
      app: app,
      error: error,
      $trackers: $trackers,
      $config: $config,
      locale: locale,
      client: client,
      isAuthenticated: isAuthenticated,
      user: user,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      tripettoRef: tripettoRef,
      tripettoToken: tripettoToken,
      backgroundImage: backgroundImage,
      surveyStarted: surveyStarted,
      surveyComplete: surveyComplete,
      numberQuestionsAnswered: numberQuestionsAnswered,
      nameQuestionYouStop: nameQuestionYouStop,
      LANGUAGE_PATHS: LANGUAGE_PATHS,
      timeStart: timeStart,
      initTripetto: initTripetto,
      AzLoader: AzLoader
    };
  }
});